import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// import RajAirTracking from './Tracking/RajAirTracking';
import JaimarutiTraking from './Tracking/JaimarutiTraking';
import ShreeramjiTracking from './Tracking/ShreeramjiTracking';
import TsscourierTracking from './Tracking/TsscourierTracking';
import AirKingTracking from './Tracking/AirKingTracking';
import SwiftcargoTracking from './Tracking/SwiftcargoTracking';
import NetAirexpress from './Tracking/NetAirexpress';
import ExpressWorldTracking from './Tracking/ExpressWorldTracking';
import RemuSupplayTracking from './Tracking/RemuSupplayTracking';
import RenuTrack from './Tracking/RenuTrack';
import KardharTracking from './Tracking/KardharTracking';
import ShriBasudevTracking from './Tracking/ShriBasudevTracking';

import AsTracking from './Tracking/AsTracking';
import Track from './Tracking/Track';





// import Pincode from './Pincodefinder/Pincode';


function App() {
  return (
    <Router>
      <div>
        {/* Other components */}
        <Routes>
          {/* Define routes for Pincode and Tracking */}
          {/* <Route path="/pincode" element={<Pincode />} /> */}
   
          
            {/* <Route path="/RajAirTracking" element={<RajAirTracking />} />  */}
            <Route path="/RenuTrack" element={<RenuTrack />} /> 
             <Route path="/SwiftcargoTracking" element={<SwiftcargoTracking />} />   
               <Route path="/ExpressWorldTracking" element={<ExpressWorldTracking />} />   
                <Route path="/RemuSupplayTracking" element={<RemuSupplayTracking />} />                
               <Route path="/AirKingTracking" element={<AirKingTracking />} /> 
                <Route path="/JaimarutiTraking" element={<JaimarutiTraking />} /> 
                 <Route path="/NetAirexpress" element={<NetAirexpress />} /> 
               <Route path="/ShreeramjiTracking" element={<ShreeramjiTracking />} /> 
               <Route path="/TsscourierTracking" element={<TsscourierTracking />} /> 
               <Route path="/KardharTracking" element={<KardharTracking />} /> 
               <Route path="/ShriBasudevTracking" element={<ShriBasudevTracking />} /> 
                <Route path="/Track" element={<Track />} /> 
                  <Route path="/AsTracking" element={<AsTracking />} /> 
        
        
                {/* <Route path="/tracking" element={<Progresss />} /> */}
        </Routes>
        {/* Other components */}
      </div>
    </Router>
  );
}

export default App;
